export default __webpack_public_path__ + "static/jordan-harband-8ccba5ed19f4c71c81185fd52f0b203d.jpg";